import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import './lib/i18n'
import { handleInstagramOAuthPopupCallback } from './services/instagramOAuthService'

// When this document is the Instagram OAuth popup it only has to hand the code
// back to the opener and close, so skip mounting the whole app into a window
// the user never sees.
const isInstagramOAuthPopup = handleInstagramOAuthPopupCallback()

if (!isInstagramOAuthPopup) {
  if (import.meta.env.DEV && typeof window !== 'undefined') {
    const { hostname, port, protocol, pathname, search, hash } = window.location
    const isLocalHost = hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '::1'
    const isStandalonePort = port === '3000' || port === '5173'

    if (isLocalHost && isStandalonePort) {
      const target = `${protocol}//${hostname}:8080${pathname}${search}${hash}`
      window.location.replace(target)
    }
  }

  createRoot(document.getElementById('root')!).render(
    <App />
  )
}
